import { useEffect } from 'react';

/**
 * Wraps useEffect but accepts async functions and passes a function to fn that when
 * called returns a boolean that denotes if the useEffect has run it's clean up function
 * 
 * @param {(isCancelled?: () => boolean) => Promise<void>} fn 
 * @param {Array} deps 
 */
const useAsyncEffect = (fn, deps) => {
  useEffect(() => {
    let cancelled = false;
    const isCancelled = () => cancelled;
    fn(isCancelled);
    return () => {
      cancelled = true;
    }
  }, deps);
}

export default useAsyncEffect;